// Service worker registration disabled — offline support moved to the mobile app.
export function register() {}
